import { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

type Props = {
    isMobile?: boolean;
};

const AnalyticsCardSkeleton: FC<Props> = () => {
    return (
        <div className='flex gap-4'>
            <div className="w-1/2 flex items-center gap-3">
                <Skeleton className="size-5 m-1.5 rounded-full" />
                <Skeleton className="max-w-30 w-full h-3 m-1.5 rounded-full" />
            </div>
            <div className="w-1/2 flex justify-end items-center gap-3">
                <Skeleton className="max-w-16 w-full h-3 m-1.5 rounded-full" />
                <Skeleton className="size-5 m-1.5 rounded-full" />
            </div>
        </div>
    );
};

export default AnalyticsCardSkeleton;
